import { styled } from '../../Utilities';
import { ColorPickerGridCellBase } from './ColorPickerGridCell.base';
import { getStyles } from './ColorPickerGridCell.styles';
export var ColorPickerGridCell = styled(ColorPickerGridCellBase, getStyles, undefined, { scope: 'ColorPickerGridCell' });
//# sourceMappingURL=ColorPickerGridCell.js.map